// extracted by mini-css-extract-plugin
export var fullGrid = "_3v-3";
export var pdpPreviewContainer = "_3v-1";
export var previewContainer = "_3v-0";
export var togglePreviewContainer = "_3v-2";